document.addEventListener('DOMContentLoaded', () => {
  const modal = document.getElementById('localization-modal');
  if (!modal) return;

  const body = document.body;
  const modalContent = modal.querySelector('.localization-content');
  const overlay = modal.querySelector('.localization-overlay');
  const triggers = document.querySelectorAll('.open-localization-modal');
  const tabs = modal.querySelectorAll('.localization-tab');
  const panels = modal.querySelectorAll('.tab-panel');
  const closeBtn = modal.querySelector('.localization-close');

  let lastFocusedElement = null;

  // Removed .localization-tab from focusable elements
  const focusableSelectors =
  'a[href], button:not([disabled]):not(.localization-tab), textarea, input, select, [tabindex]:not([tabindex="-1"])';

  const getFocusableElements = () =>
    modal.querySelectorAll(focusableSelectors);


  const trapFocus = (e) => {
    if (!modal.classList.contains('active')) return;

    const focusable = Array.from(getFocusableElements());
    if (!focusable.length) return;

    const first = focusable[0];
    const last = focusable[focusable.length - 1];

    if (e.key === 'Tab') {
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }

    if (e.key === 'Escape') {
      closeModal();
    }
  };

  const positionModal = (button) => {
    if (!button) return;

    const padding = 10;

    const { top, left, width, bottom } = button.getBoundingClientRect();
    const modalHeight = modalContent.offsetHeight;
    const modalWidth = modalContent.offsetWidth;

    let modalTop = top - modalHeight - padding;

    if (modalTop < padding) {
      modalTop = Math.min(
        bottom + padding,
        window.innerHeight - modalHeight - padding
      );
    }

    let modalLeft = Math.min(
      Math.max(left + width / 2 - modalWidth / 2, padding),
      window.innerWidth - modalWidth - padding
    );

    Object.assign(modalContent.style, {
      position: 'fixed',
      top: `${modalTop}px`,
      left: `${modalLeft}px`
    });
  };

  const openModal = (button) => {
    lastFocusedElement = button;

    modal.classList.add('active');
    modal.removeAttribute('inert');
    modal.setAttribute('aria-hidden', 'false');

    body.style.overflow = 'hidden';

    positionModal(button);

    requestAnimationFrame(() => {
      focusActivePanel();
    });

    document.addEventListener('keydown', trapFocus);
  };

  const closeModal = () => {
    modal.classList.remove('active');
    modal.setAttribute('inert', '');
    modal.setAttribute('aria-hidden', 'true');

    body.style.overflow = '';

    document.removeEventListener('keydown', trapFocus);

    lastFocusedElement?.focus();
  };

  //  Focus inside active panel (NOT tabs)
  const focusActivePanel = () => {
    const activePanel = modal.querySelector('.tab-panel.active');
    if (!activePanel) return;

    const firstButton = activePanel.querySelector('button');
    if (firstButton) {
      firstButton.focus();
    } else {
      modal.focus();
    }
  };

  // Trigger buttons
  triggers.forEach((btn) =>
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      modal.classList.contains('active')
        ? closeModal()
        : openModal(btn);
    })
  );

  overlay?.addEventListener('click', closeModal);
  closeBtn?.addEventListener('click', closeModal);

  // Tabs
tabs.forEach((tab, index) => {
  tab.setAttribute('role', 'tab');
  tab.setAttribute('aria-selected', index === 0);
  tab.setAttribute('tabindex', index === 0 ? '-1' : '0');

  tab.addEventListener('click', () => {
    activateTab(index);
    focusActivePanel();
  });

  tab.addEventListener('keydown', (e) => {
    let newIndex = index;

    if (e.key === 'ArrowRight') {
      newIndex = (index + 1) % tabs.length; // wrap around
      e.preventDefault();
    } else if (e.key === 'ArrowLeft') {
      newIndex = (index - 1 + tabs.length) % tabs.length; // wrap around
      e.preventDefault();
    }

    if (newIndex !== index) {
      activateTab(newIndex);
      tabs[newIndex].focus(); // focus stays inside the modal
    }
  });
});


  const activateTab = (index) => {
    tabs.forEach((t, i) => {
      t.classList.toggle('active', i === index);
      t.setAttribute('aria-selected', i === index);
    });

    panels.forEach((p, i) => {
      p.classList.toggle('active', i === index);
    });

    modal.classList.contains('active') && positionModal(lastFocusedElement);
  };

  const addFormSubmit = (selector, inputName) => {
    modal.querySelectorAll(selector).forEach((btn) =>
      btn.addEventListener('click', () => {
        const form = btn.closest('form');
        form.querySelector(`input[name="${inputName}"]`).value =
          btn.dataset.value;
        form.submit();
      })
    );
  };

  addFormSubmit('#currency_selector_form button', 'country_code');
  addFormSubmit('#language_selector_form button', 'language_code');

  window.addEventListener('resize', () => {
    if (!modal.classList.contains('active')) return;
    positionModal(lastFocusedElement);
  });
});




